import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ClassType } from './class-type.model';
import { ClassTypeService } from './class-type.service';
@Injectable()
export class ClassTypePopupService {
    private isOpen = false;
    constructor(
        private modalService: NgbModal,
        private router: Router,
        private classTypeService: ClassTypeService

    ) { }

    open(component: Component, id?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.classTypeService.find(id).subscribe(classType => {
                this.classTypeModalRef(component, classType);
            });
        } else {
            let classType: ClassType = new ClassType();
            classType.backOfficeUnitPriceId = null;
            classType.acceptOnlinePayments = true;
            classType.standardUnitPrice = 0.0;
            classType.active = true;
            classType.backgroundColor = '9a8e8a';
            setTimeout(() => {
                // the setTimeout is needed to avoid ExpressionChangedAfterItHasBeenCheckedError error in dev mode
                return this.classTypeModalRef(component, classType);
            });
        }
    }

    classTypeModalRef(component: Component, classType: ClassType): NgbModalRef {
        let modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.classType = classType;
        modalRef.result.then(result => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/class-type/class-type-popup.service.ts